<template>
    <component :is="showMapType" class="elePatrol"></component>
</template>
<script>
import index2DMap from './PatrolRecordDetail'
import { Cache } from '$utils'
export default {
  name: 'elePatrol',
  components: {
      index2DMap
  },
  data() {
      return {
          showMapType: 'index2DMap'
      }
  },
  computed: {},
  watch: {},
  created() {
        this.showMapTypeMethod()    
  },
    methods: {
       showMapTypeMethod() {
          //  let GetCurrentMapTypeStatus = this.$store.getters.GetCurrentMapType
          //  if(GetCurrentMapTypeStatus.currentMapType === true || JSON.stringify(this.$store.getters.GetCurrentMapType) === "{}") {
          //     this.showMapType = 'index3DMap'
          //   } else {
          //     this.showMapType = 'index2DMap'
          //   }
        }
    }
}
</script>
<style scrop>
    .elePatrol {
        width: 100%;
        height: 100%;
    }
</style>